import React from "react"
import { Badge } from "reactstrap"

const STATUS_COLORS = {
  available: "success",
  booked: "warning",
  sold: "danger",
}

export default function StatusBadge({
  value,          // can be boolean or object { name, slug }
  trueLabel = "Active",
  falseLabel = "Inactive",
  trueColor = "success",
  falseColor = "danger",
}) {
  // Handle dynamic object value
  if (value && typeof value === "object") {
    const name = value.name || "-"
    const color = STATUS_COLORS[value.slug] || "secondary"
    return <Badge className={`badge-soft-${color}`}>{name}</Badge>
  }

  // Fallback to boolean logic
  return value ? (
    <Badge className={`badge-soft-${trueColor}`}>{trueLabel}</Badge>
  ) : (
    <Badge className={`badge-soft-${falseColor}`}>{falseLabel}</Badge>
  )
}
